import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import * as styles from './ProductEmbed.css';
import type { TPostProductEmbedProps } from './ProductEmbed.types';

export const PostProductEmbed = (props: TPostProductEmbedProps) => {
  const { element, rewriteImageSrc, isIndexingDisabled } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  if (!attrs.data) {
    return null;
  }

  const { title, description, image_url, product_url, cta_text } = attrs.data;

  const processedImageUrl = rewriteImageSrc && image_url ? rewriteImageSrc(image_url) : image_url;

  return (
    <div {...anchorAttributes} className={classNames(styles.productEmbedContainer, 'flex flex-col')}>
      <div className="flex flex-col">
        <div className={styles.imageContainer}>
          <img alt={title} src={processedImageUrl} className="w-full h-full object-cover" />
        </div>
        <div className={styles.contentContainer}>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
      <a
        href={product_url}
        rel={isIndexingDisabled ? 'nofollow noopener' : undefined}
        className={styles.button}
        data-skip-tracking="true"
      >
        {cta_text}
      </a>
    </div>
  );
};
